module.exports = __webpack_public_path__ + "static/img/装饰18.af48a41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰18.svg
// module id = Bpp6
// module chunks = 2